
const tools = {
    BASE_URL: process.env.VUE_APP_API_BACKEND_URL,

    formatUnixtimestamp: function (unixtimestampValue) {
        let unixtimestamp = new Date(unixtimestampValue);
        let year = unixtimestamp.getFullYear();
        let month = "0" + (unixtimestamp.getMonth() + 1);
        let date = "0" + unixtimestamp.getDate();
        let hour = "0" + unixtimestamp.getHours();
        let minute = "0" + unixtimestamp.getMinutes();
        let second = "0" + unixtimestamp.getSeconds();
        return year + "-" + month.substring(month.length - 2, month.length) + "-" + date.substring(date.length - 2, date.length)
            + " " + hour.substring(hour.length - 2, hour.length) + ":"
            + minute.substring(minute.length - 2, minute.length) + ":"
            + second.substring(second.length - 2, second.length);
    },
    utcToGmt: function (dateStr) { //时间的格式化 2018-05-19T00:00:00.000+0000 -> 2018-05-19 00:00:00
        let datUtc = new Date(dateStr).toJSON();
        return new Date(+new Date(datUtc) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
    },
    gmtToUtc: function (dateStr) { //时间的格式化 2018-05-19 00:00:00 -> 2018-05-19T00:00:00.000+0000
        return new Date(dateStr).toISOString()
    }

};

export default tools
